import { render, staticRenderFns } from "./IntegrationPainel.vue?vue&type=template&id=4bd023a6"
import script from "./IntegrationPainel.vue?vue&type=script&lang=js"
export * from "./IntegrationPainel.vue?vue&type=script&lang=js"
import style0 from "./IntegrationPainel.vue?vue&type=style&index=0&id=4bd023a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports